import React from 'react';

import Header3 from '../typographies/header3';

const Testimonial = (props) => (
  <div className="Testimonial-testimonial">
    <blockquote className="card-blockquote Testimonial-testimonial-testimonial">
      <Header3
          key="review"
          className="white text-center Testimonial-testimonial-text"
          text={props.testimonial}
      />
    </blockquote>
    <img
        src={props.imageUrl}
        alt={props.name}
        className="Testimonial-testimonial-user-image rounded-circle"
    />
    <footer className="text white margin-t-20 text-center Testimonial-testimonial-footer">
      —<cite>
        <strong>{props.name}</strong>
      </cite>, {props.intro}
    </footer>
  </div>
);

export default Testimonial;


// WEBPACK FOOTER //
// ./src/components/testimonial/testimonial.js